import { createSlice } from '@reduxjs/toolkit'
import { keyBy } from '../../../../../helpers/common'
import { register } from '../../../../../helpers/reducerRegistry'
import { RANK_BY, TOP_COMPANY } from '../constant'
import { getTopPlayersTable, getTopYear } from './thunk'

const slice = createSlice({
  name: 'companyAnalysis/industryOverview/topPlayers',
  initialState: {
    isLoading: {
      topYear: true,
      tableData: true,
    },
    ids: [],
    data: {},
    topCompany: TOP_COMPANY.top10,
    year: {},
    rankBy: RANK_BY.netRevenue,
    topYear: [],
    isFirstLoadTableData: false,
  },
  reducers: {
    resetStore: (state) => {
      state.isLoading.topYear = true
      state.isLoading.tableData = true
      state.ids = []
      state.data = {}
      state.topYear = []
    },
    changeTopCompany: (state, action) => {
      state.topCompany = action.payload
    },
    changeYear: (state, action) => {
      state.year = action.payload
    },
    changeRankBy: (state, action) => {
      state.rankBy = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTopPlayersTable.pending, (state) => {
      state.isLoading.tableData = true
      state.data = {}
      state.ids = []
    })
    builder.addCase(getTopPlayersTable.fulfilled, (state, { payload = [] }) => {
      state.isLoading.tableData = false
      state.isFirstLoadTableData = true

      const data = payload.map((item, index) => ({
        ...item,
        id: index + 1,
      }))

      state.ids = data.map((item) => item.id)
      state.data = keyBy(data, 'id')
    })
    builder.addCase(getTopPlayersTable.rejected, (state, action) => {
      state.isLoading.tableData = action.payload.isLoading
      state.isFirstLoadTableData = true
    })

    builder.addCase(getTopYear.pending, (state) => {
      state.isLoading.topYear = true
      state.topYear = []
    })
    builder.addCase(getTopYear.fulfilled, (state, { payload = [] }) => {
      state.isLoading.topYear = false

      state.topYear = payload.sort((a, b) => b - a)
      state.year = payload.length
        ? { label: state.topYear[0], value: state.topYear[0] }
        : {}
    })
    builder.addCase(getTopYear.rejected, (state, action) => {
      state.isLoading.topYear = action.payload.isLoading
    })
  },
})

register(slice.name, slice.reducer)

export const selectTopIndustryPlayersState = (state) => state[slice.name]
export const selectIds = (state) => state[slice.name].ids
export const selectTopPlayersItem = (rowId, colId) => (state) => {
  return state[slice.name].data[rowId][colId]
}
export const selectData = (state) => state[slice.name].data
export const selectIsLoadingTopYear = (state) =>
  state[slice.name].isLoading.topYear
export const selectIsLoadingTableData = (state) =>
  state[slice.name].isLoading.tableData
export const selectIsFirstLoadTableData = (state) =>
  state[slice.name].isFirstLoadTableData
export const selectTopCompany = (state) => state[slice.name].topCompany
export const selectYear = (state) => state[slice.name].year
export const selectRankBy = (state) => state[slice.name].rankBy
export const selectTopYears = (state) => state[slice.name].topYear

export const { changeTopCompany, changeYear, changeRankBy, resetStore } =
  slice.actions
